import usePrivateLink from "../../config/usePrivateLink";
import React, { useEffect, useState } from "react";
import Footer from "../footer";
import { Link } from "react-router-dom";
import Nav from "../../master/NavBar";
import Header from "../../master/SideBar";
import {
  DemoStudentList,
  StudentBatchList,
  studentsAttendance,
} from "../../../api/StudentsAttendance";
import { getSessions } from "../../../api/SessionsService";
import { viewlist } from "../../../api/BatchService";
import { ToastMain, SweetAlertShow } from "../../master/Master";
import Swal from "sweetalert2";
import DownloadExcel from "../../master/DownloadExcel";
import AttendanceHeader from "./AttendanceHeader";

const getCurrentMonth = () => {
  const date = new Date();
  return date.toISOString().slice(0, 7); // YYYY-MM
};

const DemoMonthAttendance = () => {
  const hasAccess = usePrivateLink();
  const [viewType, setViewType] = useState("day");
  const [totalDays, setTotalDays] = useState(0);
  const [selectedAttendance, setSelectedAttendance] = useState("present");
  const [activeTab, setActiveTab] = useState(null);
  const [batch, setBatch] = useState();
  const [error, setError] = useState();
  const [selectedBatchId, setSelectedBatchId] = useState("");
  const [students, setStudents] = useState([]);
  const [batchList, setBatchList] = useState([]);
  // const [selectedMonth, setSelectedMonth] = useState('');
  const [data, setData] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [selectedSession, setSelectedSession] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(getCurrentMonth());

  const [loading, setLoading] = useState(false);

  const getMinMonth = () => {
    const now = new Date();
    now.setMonth(now.getMonth() - 5);
    return now.toISOString().slice(0, 7);
  };

  const batchliststudent = async () => {
    const addUrl = `&session_id=${selectedSession}`;
    setLoading(true);
    try {
      // console?.log("Fetching batches with status:", status); // ✅ Debugging log
      const response = await viewlist(addUrl);
      console?.log(
        "Batchlist response",
        response?.data?.batches?.[0]?.batch_fees
      );

      if (response?.data?.status) {
        setBatch(response?.data || []);
        console?.log("Batch fetched", response?.data?.batches);
      } else {
        setError("Failed to fetch batches?.");
      }
    } catch (error) {
    
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const studentBatchFetch = async () => {
    setLoading(true);
    try {
      // console.log("Fetching Students with batch_id:",);
      const response = await StudentBatchList();

      if (response.data.success) {
        setBatchList(response.data || []);
        // console.log("Students batch list in attendance fetched", response.data);
      } else {
        setError("Failed to fetch students.");
      }
    } catch (error) {
     
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    studentBatchFetch();
    getSession();
  }, []);

  useEffect(() => {
    if (selectedSession) {
      batchliststudent();
    }
  }, [selectedSession]);

  const getSession = async () => {
    setLoading(true);

    try {
      const response = await getSessions(); // <-- your API call
      if (response.data.status) {
        const activeSession = response?.data?.data.find(
          (session) => session.status === "1"
        );
        setSelectedSession(activeSession.id);
        setSessions(response?.data?.data);
      } else {
        setError("Failed to fetch session.");
      }
    } catch (error) {
     
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const studentFetch = async () => {
    setLoading(true);

    let addUrl = `&batch_id=${selectedBatchId}&month=${selectedMonth}`;
    try {
      const response = await DemoStudentList(addUrl);

      if (response.data.status) {
        setStudents(response.data.data || []);
        console.log("Students fetched", response);
      } else {
        setError("Failed to fetch students.");
      }
    } catch (error) {
     
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (selectedBatchId && selectedMonth) {
      studentFetch();
    }
  }, [selectedBatchId, selectedMonth]);

  useEffect(() => {
    if (selectedMonth) {
      const [year, month] = selectedMonth.split("-").map(Number);
      setTotalDays(new Date(year, month, 0).getDate());
    }
  }, [selectedMonth]);

  const handleDownload = () => {
    const exportData = students || [];

    console.log("Students Data: ", exportData);

    if (!Array.isArray(exportData) || exportData.length === 0) {
      alert("No data available to export");
      return;
    }

    const attendanceExport = exportData.flatMap((student, index) => {
      const studentName = student?.student_name || "N/A";
      const batchTitle = student?.batch?.title || "N/A";
      const attendanceArray = student?.attendance || [];

      if (!Array.isArray(attendanceArray) || attendanceArray.length === 0) {
        return [];
      }

      return attendanceArray.map((att) => ({
        SN: index + 1,
        "Student Name": studentName,
        Batch: batchTitle,
        Date: att.date || "N/A",
        "In Time": att.check_in_time || "N/A",
        "Out Time": att.check_out_time || "N/A",
        "Attendance Type": att.check_in === "1" ? "Present" : "Absent",
      }));
    });

    if (attendanceExport.length === 0) {
      alert("No attendance data found.");
      return;
    }

    DownloadExcel(
      attendanceExport,
      [
        "SN",
        "Student Name",
        "Batch",
        "Date",
        "In Time",
        "Out Time",
        "Attendance Type",
      ],
      "Demo Attendance Report"
    );
  };
return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid mt-2">
                <div className="row custom-scroll-layout">
                  <div className="col-md-2 left-pane">
                    <AttendanceHeader data={"Attendance Portal"} />
                  </div>
                  <div className="col-md-10 right-pane">
                    <div className="card p-4 mb-4 shadow-sm ">
                      <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
                        <div className="d-flex gap-2 flex-wrap">
                          {hasAccess('/demo_month_student/export') && (
                            <button
                              className="btn btn-success btn-sm"
                              onClick={handleDownload}
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Export Excel"
                            >
                              <i className="bi bi-cloud-arrow-down ri-20px"></i>
                            </button>
                          )}
                        </div>
                      </div>
                      <div className="row ">
                        <div>
                          <div className="container-fluid p-3 ">
                            <div className=" mb-4">
                              <div className="  rounded-4 ">
                                <form>
                                  <div className="row g-3">
                                    <div className="col-md-3 form-floating form-floating-outline">
                                      <select
                                        className="form-select"
                                        name="session"
                                        value={selectedSession}
                                        onChange={(e) =>
                                          setSelectedSession(e.target.value)
                                        }
                                      >
                                        {sessions?.map((session) => (
                                          <option
                                            key={session?.id}
                                            value={session?.id}
                                          >
                                            {session?.session}:
                                            {session?.status == "1"
                                              ? "Active"
                                              : " Inactive"}
                                            {/* Show "2023-24" */}
                                          </option>
                                        ))}
                                      </select>

                                      <label>Filter Session</label>
                                    </div>

                                    <div className="col-md-3 form-floating form-floating-outline">
                                      <select
                                        className="form-control"
                                        onChange={(e) => {
                                          setSelectedBatchId(e?.target?.value); // ← Add this
                                        }}
                                        value={selectedBatchId}
                                        required
                                      >
                                        <option value="">Select Batch</option>
                                        {batch?.batches?.map((batch) => (
                                          <option
                                            key={batch?.id}
                                            value={batch?.id}
                                          >
                                            {batch?.title}
                                          </option>
                                        ))}
                                      </select>
                                      <label>Select Batch</label>
                                    </div>

                                    <div className="col-md-3 form-floating form-floating-outline">
                                      <input
                                        type="month"
                                        className="form-control"
                                        value={selectedMonth}
                                        onChange={(e) =>
                                          setSelectedMonth(e.target.value)
                                        }
                                        min={getMinMonth()}
                                        max={getCurrentMonth()}
                                      />
                                      <label>Select Month</label>
                                    </div>
                                  </div>
                                </form>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card p-4 mb-4 ">
                      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap mb-5">
                        <strong className="fw-bold fs-5">
                          Demo Students List
                        </strong>
                      </div>

                      {/* Record Selector */}

                      {/* Table */}

                      <div className="table-responsive">
                        <table className="table table-bordered attendance-table">
                          <thead>
                            <tr>
                              <th>#</th>
                              {/* <th>Registration No</th> */}
                              <th>Name</th>
                              <th>Mobile</th>

                              {[...Array(totalDays)].map((_, i) => (
                                <th key={i}>{i + 1}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {students.map((item, index) => (
                              <tr>
                                <td>{item?.id}</td>
                                {/* <td>{item?.registration_no}</td> */}
                                <td>{item?.student_name}</td>
                                <td>{item?.mobile}</td>
                                {[...Array(totalDays)].map((_, i) => {
                                  const day = String(i + 1).padStart(2, "0");
                                  const currentDate = `${selectedMonth}-${day}`; // e.g., 2025-07-26

                                  const today = new Date();
                                  const currentCheckDate = new Date(
                                    `${selectedMonth}-${day}`
                                  );

                                  const isSunday =
                                    currentCheckDate.getDay() === 0;

                                  const attendance = item?.attendance?.find(
                                    (att) => att.date === currentDate
                                  );

                                  const isFuture = currentCheckDate > today;

                                  let cellValue = "-";
                                  let cellClass = "";

                                  if (isSunday) {
                                    cellValue = "Sun";
                                    cellClass = "text-primary fw-bold"; // blue for Sunday
                                  } else if (!isFuture) {
                                    if (attendance) {
                                      if (attendance.check_in === "1") {
                                        cellValue = "P";
                                        cellClass = "text-success fw-bold"; // green
                                      } else if (
                                        attendance.check_in === "2"
                                      ) {
                                        cellValue = "A";
                                        cellClass = "text-danger fw-bold"; // red
                                      }
                                    } else {
                                      cellValue = "";
                                      cellClass = "text-danger fw-bold"; // red
                                    }
                                  }

                                  return (
                                    <td key={i} className={cellClass}>
                                      {cellValue}
                                    </td>
                                  );
                                })}

                                {/* <td>
                                                                {itme?.student_info?.attendance?.map((att, index) => (
                                                                    <span key={index}>
                                                                        {att === 1 ? "P" : "A"}{" "}
                                                                    </span>
                                                                ))}
                                                            </td> */}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DemoMonthAttendance;
